module.exports = __webpack_public_path__ + "static/AxiformaBlack-1225d005836ffbb22d450ac59949cc98.otf";